const getters = {
  // getCount: state => state.count,
}

export default getters



// WEBPACK FOOTER //
// ./src/vuex/getters.js